import AchievementDetail from './AchievementDetail';

export default AchievementDetail;
